import React from "react";
import { Button, ButtonProps } from "antd";
import { cn  } from "../../../lib/utils";

interface ButtonWrapperProps extends ButtonProps {
  children: React.ReactNode;
  className?: string;
}

const ButtonWrapper: React.FC<ButtonWrapperProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <Button {...props} className={cn("!py-2 !px-4 !rounded-lg !shadow-none", className)}>
      {children}
    </Button>
  );
};

export default ButtonWrapper;
